const gallery = {
  allDesigns: "All Designs",
  preview: "Preview",
  openDesign: "Open Design",
  backToGallery: "Back to Gallery",
  noDesigns: "No designs yet",
  route: "Route",
  createdAt: "Created",
  tags: "Tags",
  landing: "Landing Page",
  website: "Website",
  dashboard: "Dashboard",
  component: "Component",
} as const;
export default gallery;
